module.exports = {"cart":"Cart - FR","generalAdmission":"GA - FR","reservedSeating":"RS - FR","flexpass":"FL - FR","totalItems":"Total items - FR","totalItem":"Total item - FR","subtotal":"Subtotal - FR","showtixFees":"Showtix4u fees - FR","callCenterFees":"Call center fees - FR","miscFees":"Misc fees - FR","total":"Total - FR","checkout":"Checkout - FR","cartSummary":"Cart Summary - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/locales/fr.json
// module id = 409
// module chunks = 0